import dayjs from 'dayjs'
import jalaliday from 'jalaliday'
import utc from 'dayjs/plugin/utc'
import { langShortName } from './locales'
dayjs.extend(jalaliday)
dayjs.extend(utc)
const lang = langShortName(localStorage.getItem('lang') ?? 'English')
dayjs.prototype.display = function(format) {
    if (lang === 'fa') return this.calendar('jalali').locale(lang).format(format)
    return this.locale(lang).format(format)
}
export default dayjs